import { render, staticRenderFns } from "./ServeDialog.vue?vue&type=template&id=680c0811&scoped=true&"
import script from "./ServeDialog.vue?vue&type=script&lang=js&"
export * from "./ServeDialog.vue?vue&type=script&lang=js&"
import style0 from "./ServeDialog.vue?vue&type=style&index=0&id=680c0811&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680c0811",
  null
  
)

export default component.exports